import { ProConfigProvider } from '@ant-design/pro-components';
import { useAntdConfig } from '@umijs/max';
import { useTheme } from '@zhiyue/core';
import { App, ConfigProvider } from 'antd';
import React from 'react';
import { platformTheme } from './themeConfig';

/** Reset inherited layout palettes at the content boundary; Pro controls share the same mode. */
export default function PlatformThemeBoundary({
  children,
}: React.PropsWithChildren) {
  const { navTheme } = useTheme();
  const config = useAntdConfig();
  const activeTheme = React.useMemo(
    () => platformTheme(config?.theme, navTheme === 'realDark'),
    [config?.theme, navTheme],
  );
  React.useEffect(() => {
    // Static message/notification/Modal APIs mount outside the business App tree.
    ConfigProvider.config({
      holderRender: (holder) => (
        <ConfigProvider {...config} theme={{ ...activeTheme, inherit: false }}>
          {holder}
        </ConfigProvider>
      ),
    });
  }, [config, activeTheme]);
  return (
    <ConfigProvider {...config} theme={{ ...activeTheme, inherit: false }}>
      <ProConfigProvider dark={navTheme === 'realDark'}>
        <App className="platform-content">{children}</App>
      </ProConfigProvider>
    </ConfigProvider>
  );
}
